import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./styles/theme";
import "./styles/global.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Suppress ResizeObserver loop error (Chrome bug)
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.toString()?.includes("ResizeObserver loop completed")) {
    return;
  }
  resizeObserverErr(...args);
};
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>,
);


